import { render, staticRenderFns } from "./CustomerSidebar.vue?vue&type=template&id=3b193771&scoped=true&"
import script from "./CustomerSidebar.vue?vue&type=script&lang=js&"
export * from "./CustomerSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSidebar.vue?vue&type=style&index=0&id=3b193771&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b193771",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b193771')) {
      api.createRecord('3b193771', component.options)
    } else {
      api.reload('3b193771', component.options)
    }
    module.hot.accept("./CustomerSidebar.vue?vue&type=template&id=3b193771&scoped=true&", function () {
      api.rerender('3b193771', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Customer/CustomerSidebar.vue"
export default component.exports